import useWindowSize from './use-window-size';

export const useMediaQuery = () => {
    const size = useWindowSize();

    return {
        xxs: size.width <= 480,
        xs: size.width <= 768,
        sm: size.width <= 1024,
        md: size.width <= 1440,
    };
};
